import { useState } from 'react'
import { API } from '../../../../api'
import { useDispatch } from 'react-redux'
import { setVisitedMembershipId } from '../../../../store/reducer/ad-management'
import { IQDialog, Preloader } from '../../../common'
import Button from '@mui/material/Button'
import { trimAndReplaceWhiteSpaces } from '../../../../utility/string-format'
import { Stack } from '@mui/material'

interface IProps {
  isShow: boolean
  name: string
  templateName?: string
  description: string
  templateGroups: Record<string, { name: string; description: string }[]>
  groups: string[]
  isCreateCoveredEntity: boolean
  onSuccess: () => void
  onCancel: () => void
  onCreateAnother: () => void
  type: 'INT' | 'EXT' | 'TEMPLATE'
}

export const MembershipCreate = ({
  isShow,
  name,
  templateName,
  description,
  type,
  groups,
  templateGroups,
  isCreateCoveredEntity,
  onSuccess,
  onCancel,
  onCreateAnother,
}: IProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()

  const handleCreate = async () => {
    try {
      setIsLoading(true)
      if (type === 'TEMPLATE') {
        await API.ADManagement.membership.createTemplate(trimAndReplaceWhiteSpaces(templateName || ''), templateGroups)
      } else {
        await API.ADManagement.membership.create(trimAndReplaceWhiteSpaces(name), trimAndReplaceWhiteSpaces(description), groups, type)
        isCreateCoveredEntity ? dispatch(setVisitedMembershipId(name)) : false
      }
      return true
    } catch {
      onCancel()
      return false
    } finally {
      setIsLoading(false)
    }
  }

  const handleSave = async () => {
    const success = await handleCreate()
    if (success) onSuccess()
  }

  const handleSaveAndCreateAnother = async () => {
    const success = await handleCreate()
    if (success) onCreateAnother()
  }

  const renderCreateActions = () => (
    <Stack
      direction='row'
      spacing={2}
      justifyContent='space-between'
      sx={{ width: '100%' }}
    >
      <Button
        onClick={() => onCancel()}
        variant='outlined'
        data-testid={`${type === 'TEMPLATE' ? 'template' : 'membership'}-create-cancel`}
      >
        Cancel
      </Button>
      <Stack
        direction='row'
        spacing={2}
        justifyContent='space-between'
      >
        {!isCreateCoveredEntity && type !== 'TEMPLATE' && (
          <Button
            disabled={isLoading}
            variant='contained'
            onClick={handleSaveAndCreateAnother}
            data-testid='CE-save-and-create-another'
          >
            Save and Create another Membership
          </Button>
        )}
        <Button
          disabled={isLoading}
          variant='contained'
          onClick={handleSave}
          data-testid={`CE-${type === 'TEMPLATE' ? 'template' : 'membership'}-create-save`}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  )

  return (
    <IQDialog
      isShow={isShow}
      title={`Are you sure you want to save this ${type === 'TEMPLATE' ? 'Template' : 'Membership'}?`}
      content={
        isLoading ? (
          <Preloader
            size='sm'
            style={{ display: 'block', margin: '0 auto' }}
          />
        ) : (
          false
        )
      }
      actions={renderCreateActions()}
      onClose={() => onCancel()}
      testPrefix='membership-create'
    />
  )
}
